import { render, staticRenderFns } from "./ModalChangeGroup.vue?vue&type=template&id=8775f45c"
import script from "./ModalChangeGroup.vue?vue&type=script&lang=js"
export * from "./ModalChangeGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports